import { betrag } from './sprache'

/**
 * **Jeder Betrag wird von diesem Baustein gesetzt** (7.2 Abschnitt 53,
 * R1632): Schreibweise, Größe und die Farbe des negativen Betrags.
 *
 * **Die Farbe wählt der Anwender** (R1015): Der Baustein setzt nur `minus`;
 * ob das rot oder schwarz ist, entscheidet das Gestaltungsblatt nach seiner
 * Wahl, und das Rot schlägt jede Färbung der Zeile (R1374).
 *
 * **Der Befund vom 2026-10-12:** Im Prozessfenster stand −1.558,78 schwarz und
 * in 13 bis 14 Pixeln, im Bericht rot in 12,5 — jede Seite färbte ihre Beträge
 * selbst, und acht taten es nicht. Ein Prüffall meldet jeden Betrag, der an
 * diesem Baustein vorbei geschrieben wird.
 */
export function Betrag({
  wert,
  leerBeiNull = false,
  waehrung,
}: {
  wert: number
  /** Eine Null bleibt leer — wie in den Zellen eines Berichts. */
  leerBeiNull?: boolean
  /** Die Währung dahinter, wo die Spalte sie nicht nennt. */
  waehrung?: string
}) {
  if (leerBeiNull && wert === 0) {
    return null
  }

  return (
    <span className={wert < 0 ? 'zahl betragswert minus' : 'zahl betragswert'}>
      {betrag(wert)}
      {waehrung ? ` ${waehrung}` : ''}
    </span>
  )
}
